import { Box } from '@mui/material';
import BaseInputNumber from 'common/components/base-input-number';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import lodash from 'lodash';
import { colors } from 'common/constants';
import { createStyleSheet } from 'utils/helpers';
import { common } from '@mui/material/colors';
interface IProps {
    name: string;
}
const isLeapYear = (year: number) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

const getDaysInMonth = (month: number, year: number) => {
    if (month === 2) {
        return isLeapYear(year) ? 29 : 28;
    }
    if ([4, 6, 9, 11].includes(month)) {
        return 30;
    }
    return 31;
};
const QuestionDate: React.FC<IProps> = ({ name }) => {
    const { watch, setValue } = useFormContext();
    const day = watch(`${name}.day`);
    const month = watch(`${name}.month`);
    const year = watch(`${name}.year`);
    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 100;
    const maxYear = currentYear + 100;

    const debouncedSetYear = lodash.debounce((name, year) => {
        if (year > maxYear) {
            setValue(`${name}.year`, maxYear);
        } else if (year < minYear) {
            setValue(`${name}.year`, minYear);
        } else {
            setValue(`${name}.year`, year);
        }
    }, 1000);

    useEffect(() => {
        if (month || day || year) {
            if (month || month === 0) {
                if (month > 12) {
                    setValue(`${name}.month`, 12);
                } else if (month < 1) {
                    setValue(`${name}.month`, 1);
                }
            }

            if (day || day === 0) {
                if (day > 31) {
                    setValue(`${name}.day`, 31);
                } else if (day < 1) {
                    setValue(`${name}.day`, 1);
                }
            }

            if (month && year) {
                const maxDays = getDaysInMonth(month, year);

                if (day > maxDays) {
                    setValue(`${name}.day`, maxDays);
                }
            }

            if (year) {
                if (year > maxYear) {
                    setValue(`${name}.year`, maxYear);
                } else {
                    debouncedSetYear(name, year);
                }
            }
        }

        return () => {
            debouncedSetYear.cancel();
        };
    }, [month, day, year, setValue, name, debouncedSetYear, maxYear]);

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'baseline',
                }}
            >
                <Box
                    sx={{
                        ...styles.wrapper,
                        width: ['40%', '10%'],
                    }}
                >
                    <Box sx={styles.label}>Ngày</Box>
                    <BaseInputNumber
                        name={`${name}.day`}
                        placeholder="DD"
                        sx={{
                            ...styles.input,
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        color: [common.white, colors.main],
                        fontSize: ['3rem', '3rem', '3rem', '5rem', '5rem'],
                        alignSelf: 'flex-end',
                    }}
                >
                    /
                </Box>
                <Box
                    sx={{
                        ...styles.wrapper,
                        width: ['40%', '10%'],
                    }}
                >
                    <Box sx={styles.label}>Tháng</Box>
                    <BaseInputNumber
                        name={`${name}.month`}
                        placeholder="MM"
                        sx={{
                            ...styles.input,
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        color: [common.white, colors.main],
                        fontSize: ['3rem', '3rem', '3rem', '5rem', '5rem'],
                        alignSelf: 'flex-end',
                    }}
                >
                    /
                </Box>
                <Box
                    sx={{
                        ...styles.wrapper,
                        width: ['50%', '20%'],
                    }}
                >
                    <Box sx={styles.label}>Năm</Box>
                    <BaseInputNumber
                        name={`${name}.year`}
                        placeholder="YYYY"
                        sx={{
                            ...styles.input,
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};
const styles = createStyleSheet({
    input: {
        '& .MuiInputBase-root': {
            borderRadius: '0px',
            fontSize: ['2rem', '1.5rem', '1.5rem', '3rem', '3rem'],
            color: [common.white, '#8B8B8B'],
        },
        '& .MuiOutlinedInput-root': {
            border: 'none',
            '& fieldset': {
                border: 'none',
                borderBottom: ['1px solid #fff', '1px solid #8B8B8B'],
            },
            '&:hover fieldset': {
                borderBottom: '1px solid #8B8B8B',
            },
            '&.Mui-focused fieldset': {
                borderBottom: [
                    `4px solid ${common.white}`,
                    `4px solid ${colors.main}`,
                ],
            },
        },
    },
    label: {
        marginLeft: 2,
        color: [common.white, '#8B8B8B'],
        fontSize: ['1rem', '1rem', '1rem', '1.5rem', '1.5rem'],
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        gap: [0, 1],
    },
});
export default QuestionDate;
